import {
  BrowserRouter,
  useLocation,
  useNavigate,
  useRoutes
} from 'react-router-dom';
import {
  buildRulesAndTriggers,
  extractPageRule,
  initialVisibilitySetup,
  runDisplayPropsRules
} from 'reg_redesign/helper';
import { connect, Provider, useSelector } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
  defaultMapDispatchToProps,
  defaultMapStateToProps
} from './redux/connectFunctions';
import { Desktop, LargeMobile, SmallMobile } from 'styles/MediaQueries';
import { isFunction } from 'lodash';
import { ScrollToTop } from 'react-router-scroll-to-top';
import { SET_DATA } from 'helpers/Constants';
import { store } from 'reg_redesign/redux/store';
import config from 'reg_redesign/config';
import displayPropsRules from 'reg_redesign/displayPropsRules';
import React, { useEffect } from 'react';
import RegPage from 'registration/RegPage';
import SiteHeader from '@opploans/site-header-component/SiteHeader';

window.setData = (obj) => {
  store.dispatch({ type: SET_DATA, payload: obj });
};

const containerStyles = {
  '.MuiFormControl-root': {
    width: '100%'
  },
  '.MuiTooltip-popper': {
    width: '100%'
  }
};

const contentStyles = {
  margin: 'auto',
  [Desktop]: {
    width: '30rem'
  },
  [SmallMobile]: {
    width: '100%'
  },
  [LargeMobile]: {
    width: '100%',
    maxWidth: '30rem'
  },
  padding: '5rem 0'
};

const RegRoutes = () => {
  const navigate = useNavigate();
  const routes = Object.keys(config).map((key) => {
    return {
      path: `/register/${key}`,
      element: (
        <div>
          {config[key].content.map((field) => {
            const mapStateToProps = isFunction(field.stateToPropsOverride)
              ? field.stateToPropsOverride(field)
              : defaultMapStateToProps(field);

            const mapDispatchToProps = isFunction(field.dispatchOverride)
              ? field.dispatchOverride(field, navigate)
              : defaultMapDispatchToProps(field);

            const Field = connect(
              mapStateToProps,
              mapDispatchToProps
            )(field.component);

            return (
              <Field key={field?.props?.id || field.name} {...field.props} />
            );
          })}
        </div>
      )
    };
  });
  return useRoutes(routes);
};

buildRulesAndTriggers(store, displayPropsRules);
initialVisibilitySetup(store, config);
extractPageRule(store, config);

export const RegRedesign = () => {
  window.trackVisitEvent();
  return (
    <Provider store={store}>
      <RegPageContent />
    </Provider>
  );
};

function RegPageContent() {
  const provider = useSelector((state) => state.productOwner);

  return (
    <div css={containerStyles}>
      <SiteHeader provider={provider} />
      <div css={contentStyles}>
        <RegPage>
          <BrowserRouter>
            <ScrollToTop />
            <RegRedesignContentInner />
          </BrowserRouter>
        </RegPage>
      </div>
    </div>
  );
}

function RegRedesignContentInner() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // This is so that the footer will display after the form had loaded, see reg_redesign.slim
    if (document.getElementsByClassName('footer-container')[0]) {
      document.getElementsByClassName('footer-container')[0].style.display =
        'block';
    }
    window.postHeapAnalytic('track', '[reg-16][page][bank_info_hidden]', {
      bank_info_hidden: window.AppConfig?.hide_bank_info_section
    });
    navigate(`/register/page-1${window.location.search}`);
    runDisplayPropsRules(store.getState(), store.dispatch, displayPropsRules);
  }, []);

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.key}
        classNames='slide-left'
        timeout={800}
        exit={false}
      >
        <RegRoutes />
      </CSSTransition>
    </TransitionGroup>
  );
}
